import { render, staticRenderFns } from "./IncomeAndExpenditureEdit.vue?vue&type=template&id=87a4b71a&"
import script from "./IncomeAndExpenditureEdit.vue?vue&type=script&lang=js&"
export * from "./IncomeAndExpenditureEdit.vue?vue&type=script&lang=js&"
import style0 from "./IncomeAndExpenditureEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports